<template>
  <div>
    <template v-if="item.Value.Name">
      <div :class="needsDisable ? '' : 'imageContainer'">
        <img
          class="pageImage"
          :src="
            serverUrl +
            '/images/' +
            websiteId +
            '/' +
            item.Value.Name +
            '?token=' +
            userToken
          "
        />
        <v-layout row wrap class="editContainer mt-2 mt-2 pl-3 pr-3">
          <template v-if="(!item.ReadOnly && !needsDisable) || editItemAdmin">
            <template v-if="item.AddAltTags || item.AddAltTags == null">
              <template v-if="item.Translate || item.Translate == undefined">
                <v-flex lg3 sm3 xs12 pr-4>
                  <v-select
                    :items="itemLanguages"
                    v-model="itemDefaultLanguage"
                    single-line
                    class="altSelect"
                  ></v-select>
                </v-flex>
              </template>
              <template>
                <v-flex lg7 sm7 xs10 pr-4>
                  <template
                    v-for="(translatedValue, translatedValueIndex) in item.Value
                      .Alt"
                  >
                    <template
                      v-if="itemDefaultLanguage == translatedValueIndex"
                    >
                      <input
                        :key="translatedValueIndex"
                        type="text"
                        class="textInput"
                        placeholder="Alt tag"
                        v-model="item.Value.Alt[translatedValueIndex]"
                      />
                    </template>
                  </template>
                </v-flex>
              </template>
            </template>
            <v-flex lg2 sm2 xs2>
              <v-btn
                color="error"
                class="customRemoveButton"
                icon
                @click="deleteImage(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-flex>
          </template>
        </v-layout>
      </div>
    </template>

    <!-- If no image was saved -->
    <template v-else-if="!item.ReadOnly || editItemAdmin">
      <v-layout row wrap class="mt-2">
        <v-flex lg6 sm12>
          <VueCropper
            v-show="selectedImageToCrop"
            class="mb-3"
            ref="cropper"
            :src="selectedImageToCrop"
            :aspectRatio="item.Width / item.Height"
          >
          </VueCropper>
        </v-flex>
      </v-layout>

      <input
        :ref="'fileInput' + objectName"
        class="fileInput"
        type="file"
        @change="onCroppedImageSelect"
      />

      <v-btn
        class="ml-0 mt-3 mr-3 edit-page-action-button"
        @click="$refs['fileInput' + objectName].click()"
        color="primary"
        >{{ $t("Choose an image") }}</v-btn
      >
      <v-btn
        color="blue-grey"
        class="ml-0 mt-3 white--text edit-page-action-button"
        :disabled="!file || uploading || uploadError.length > 0"
        :loading="uploading"
        v-on:click="submitCroppedImage(item)"
        >{{ $t("Upload") }}<v-icon right dark>mdi-cloud-upload</v-icon></v-btn
      >
      <errorHandeling
        v-if="uploadError"
        :snackbarText="uploadError"
        :buttons="[
          { isText: true, functionName: 'reportError', text: 'Report error' },
          {
            isText: true,
            functionName: 'clearError',
            text: 'Close',
          },
        ]"
        snackbarColor="error"
        snackbarTimout="-1"
        snackbarIcon="mdi-alert-circle"
        @clearError="$emit('setUploadError', '')"
      />
    </template>

    <template v-if="$store.getters.editMode">
      <hr class="mt-5" />
      <v-row no-gutters class="my-5">
        <v-col cols="12">
          <v-text-field
            :label="$t('Width in pixels')"
            v-model="item.Width"
            dense
            class="float-left mr-3"
            hide-details="auto"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            :label="$t('Height in pixels')"
            v-model="item.Height"
            dense
            class="float-left mr-3 mt-5"
            hide-details="auto"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters class="my-5">
        <v-col cols="12">
          <v-layout column>
            <v-text-field
              v-model.number="item.colWidth"
              hide-details="auto"
              type="number"
              max="12"
              min="1"
              dense
              :label="$t('Column width')"
              class="mw-w"
            ></v-text-field>
            <v-switch
              v-model="item.Translate"
              class="float-left mr-3"
              hide-details="auto"
              :label="$t('Translate item')"
            ></v-switch>
            <v-switch
              v-model="item.AddAltTags"
              class="float-left mr-3"
              hide-details="auto"
              :label="$t('Add alt tags')"
            ></v-switch>
            <v-switch
              v-model="item.ReadOnly"
              hide-details="auto"
              class="float-left mr-3"
              :label="$t('Read-only')"
            ></v-switch>
          </v-layout>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  components: { VueCropper },
  props: {
    item: {
      type: [Array, Object],
    },
    needsDisable: {
      type: Boolean,
    },
    websiteId: {
      type: String,
    },
    pageId: {
      type: String,
    },
    objectName: {
      type: [Array, Object, String],
    },
    uploadError: {},
    editItemAdmin: {
      type: Boolean,
    },
  },
  data() {
    return {
      userToken: this.$auth.userToken(),
      itemLanguages: this.getItemLanguages(),
      itemDefaultLanguage: this.getItemDefaultLanguage(),
      serverUrl: this.$helpers.getServerUrl(),
      uploading: false,
      file: null,
      selectedImageToCrop: null,
    };
  },
  methods: {
    deleteImage(item) {
      item.Value.Name = "";
    },
    getItemDefaultLanguage() {
      return this.$config.contentLanguages[0];
    },
    getItemLanguages() {
      return this.$config.contentLanguages;
    },
    onCroppedImageSelect(e) {
      this.file = e.target.files[0];
      this.mime_type = this.file.type;

      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.selectedImageToCrop = event.target.result;
          this.$refs.cropper.replace(this.selectedImageToCrop);
        };
        reader.readAsDataURL(this.file);
      }
    },
    submitCroppedImage(item) {
      this.uploading = true;
      this.$emit("update:saving", true);
      this.$emit("setUploadError", "");

      this.$refs.cropper
        .getCroppedCanvas({ width: this.item.Width })
        .toBlob((blob) => {
          let formData = new FormData();
          formData.append("files", blob, this.file.name);

          this.$request.post(
            "/content/imageupload/" + this.pageId,
            formData,
            (res) => {
              this.uploading = false;
              this.$emit("update:saving", false);
              this.$refs["fileInput" + this.objectName].value = null;

              if (res.success) {
                item.Value.Name = res.data[0];
                this.file = null;
              } else {
                this.$emit("setUploadError", res.message);
              }
            }
          );
        }, this.mime_type);
    },
  },
};
</script>

<style scoped>
.fileInput {
  display: none;
}
.mw-w {
  min-width: 2rem;
  max-width: 8rem;
}
.imageContainer {
  position: relative;
  display: table;
  background-color: #fff;
  border: 1px solid #e4e4e4;
  cursor: pointer;
}

.imageContainer img {
  opacity: 1;
  margin-bottom: -6px;
}

.imageContainer:hover img,
.imageContainer:focus img {
  opacity: 0.6;
}

.imageContainer .editContainer {
  background-color: #fff;
  display: none;
  width: 100%;
}

.imageContainer .editContainer .textInput {
  margin: 18px 0;
}

.imageContainer .editContainer .customRemoveButton {
  margin: 14px 0;
}

.imageContainer:hover .editContainer,
.imageContainer:focus .editContainer {
  display: flex;
}
</style>